// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Redirect = require("../../reason/common/Redirect.bs.js");
let Container = require("../common/Components/Container.bs.js");
let PageTitle = require("../common/Components/PageTitle.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let PasswordPage = require("./PasswordPage.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let UseRelayPolling = require("../common/Hooks/UseRelayPolling.bs.js");
let ViewPreferences = require("./ViewPreferences.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let SubusersPageRelay = require("./SubusersPageRelay.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnifiedProfileSubpages = require("./UnifiedProfileSubpages.bs.js");
let UnifiedSettingsRecovery = require("./UnifiedSettingsRecovery.bs.js");
let BillingSettingsPageRelay = require("./BillingSettingsPageRelay.bs.js");
let EmailPreferencesPageRelay = require("./EmailPreferencesPageRelay.bs.js");
let UnifiedSettingsPageSidebar = require("./UnifiedSettingsPageSidebar.bs.js");
let UnifiedYourProfileSettings = require("./UnifiedYourProfileSettings.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedAddDisplayOnlyMember = require("./UnifiedAddDisplayOnlyMember.bs.js");
let UnifiedEditDisplayOnlyMember = require("./UnifiedEditDisplayOnlyMember.bs.js");
let UnifiedAccountProfileSettings = require("./UnifiedAccountProfileSettings.bs.js");
let UnifiedYourProfileAboutSettings = require("./UnifiedYourProfileAboutSettings.bs.js");
let UnifiedAccountProfileUrlSettings = require("./UnifiedAccountProfileUrlSettings.bs.js");
let UnifiedYourProfilePhotosSettings = require("./UnifiedYourProfilePhotosSettings.bs.js");
let UnifiedYourProfileBasicInfoSettings = require("./UnifiedYourProfileBasicInfoSettings.bs.js");
let UnifiedYourProfileSocialMediaSettings = require("./UnifiedYourProfileSocialMediaSettings.bs.js");
let UnifiedTeamAccountProfileAboutSettings = require("./UnifiedTeamAccountProfileAboutSettings.bs.js");
let UnifiedAccountSettingsPageQuery_graphql = require("../../__generated__/UnifiedAccountSettingsPageQuery_graphql.bs.js");
let UnifiedTeamAccountProfilePhotosSettings = require("./UnifiedTeamAccountProfilePhotosSettings.bs.js");
let UnifiedAccountSettingsPage_query_graphql = require("../../__generated__/UnifiedAccountSettingsPage_query_graphql.bs.js");
let UnifiedTeamAccountProfileMembersSettings = require("./UnifiedTeamAccountProfileMembersSettings.bs.js");
let UnifiedTeamAccountProfileBasicInfoSettings = require("./UnifiedTeamAccountProfileBasicInfoSettings.bs.js");
let UnifiedTeamAccountProfileSocialMediaSettings = require("./UnifiedTeamAccountProfileSocialMediaSettings.bs.js");
let UnifiedAccountSettingsPageRefetchQuery_graphql = require("../../__generated__/UnifiedAccountSettingsPageRefetchQuery_graphql.bs.js");

let convertFragment = UnifiedAccountSettingsPage_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedAccountSettingsPage_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedAccountSettingsPage_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedAccountSettingsPage_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedAccountSettingsPage_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = UnifiedAccountSettingsPageRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = UnifiedAccountSettingsPageRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(UnifiedAccountSettingsPage_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

let convertVariables = UnifiedAccountSettingsPageQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedAccountSettingsPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedAccountSettingsPageQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables, UnifiedAccountSettingsPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedAccountSettingsPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedAccountSettingsPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedAccountSettingsPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedAccountSettingsPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedAccountSettingsPageQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedAccountSettingsPage$Settings(props) {
  let billingEnabled = UserSession.useChapterPreference("PayingChapter") === "ON";
  let settingPath = Stdlib_List.fromArray(props.setting);
  let accountProfileName = UnifiedProfileSubpages.accountProfileName(props.profileType);
  let tmp;
  if (settingPath !== 0) {
    switch (settingPath.hd) {
      case "account_profile" :
        tmp = accountProfileName;
        break;
      case "billing" :
        tmp = settingPath.tl !== 0 ? "Settings" : "Billing Settings";
        break;
      case "email_notifications" :
        tmp = settingPath.tl !== 0 ? "Settings" : "Email Notifications Settings";
        break;
      case "password" :
        tmp = settingPath.tl !== 0 ? "Settings" : "Password Settings";
        break;
      case "preferences" :
        tmp = settingPath.tl !== 0 ? "Settings" : "Preferences";
        break;
      case "profile" :
        tmp = "Your Profile";
        break;
      case "users" :
        tmp = settingPath.tl !== 0 ? "Settings" : "Users Settings";
        break;
      default:
        tmp = "Settings";
    }
  } else {
    tmp = "Settings";
  }
  let tmp$1;
  if (settingPath !== 0) {
    switch (settingPath.hd) {
      case "account_profile" :
        let match = settingPath.tl;
        if (match !== 0) {
          switch (match.hd) {
            case "about" :
              tmp$1 = match.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/account_profile"
                }) : JsxRuntime.jsx(UnifiedTeamAccountProfileAboutSettings.make, {});
              break;
            case "basic_info" :
              tmp$1 = match.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/account_profile"
                }) : JsxRuntime.jsx(UnifiedTeamAccountProfileBasicInfoSettings.make, {});
              break;
            case "members" :
              let match$1 = match.tl;
              if (match$1 !== 0) {
                let memberId = match$1.hd;
                let exit = 0;
                if (memberId === "new" && match$1.tl === 0) {
                  tmp$1 = JsxRuntime.jsx(UnifiedAddDisplayOnlyMember.make, {});
                } else {
                  exit = 1;
                }
                if (exit === 1) {
                  let match$2 = match$1.tl;
                  tmp$1 = match$2 !== 0 && match$2.hd === "edit" && match$2.tl === 0 ? JsxRuntime.jsx(UnifiedEditDisplayOnlyMember.make, {
                      memberId: memberId
                    }) : JsxRuntime.jsx(Redirect.make, {
                      path: "/account/account_profile"
                    });
                }
              } else {
                tmp$1 = JsxRuntime.jsx(UnifiedTeamAccountProfileMembersSettings.make, {});
              }
              break;
            case "photos" :
              tmp$1 = match.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/account_profile"
                }) : JsxRuntime.jsx(UnifiedTeamAccountProfilePhotosSettings.make, {});
              break;
            case "social_media" :
              tmp$1 = match.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/account_profile"
                }) : JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings.make, {});
              break;
            case "url" :
              tmp$1 = match.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/account_profile"
                }) : JsxRuntime.jsx(UnifiedAccountProfileUrlSettings.make, {});
              break;
            default:
              tmp$1 = JsxRuntime.jsx(Redirect.make, {
                path: "/account/account_profile"
              });
          }
        } else {
          tmp$1 = JsxRuntime.jsx(UnifiedAccountProfileSettings.make, {});
        }
        break;
      case "billing" :
        tmp$1 = settingPath.tl !== 0 || !billingEnabled ? "This doesn't seem to be a valid URL" : JsxRuntime.jsx(BillingSettingsPageRelay.make, {});
        break;
      case "email_notifications" :
        tmp$1 = settingPath.tl !== 0 ? "This doesn't seem to be a valid URL" : JsxRuntime.jsx(EmailPreferencesPageRelay.make, {});
        break;
      case "password" :
        tmp$1 = settingPath.tl !== 0 ? "This doesn't seem to be a valid URL" : JsxRuntime.jsx(PasswordPage.make, {});
        break;
      case "preferences" :
        tmp$1 = settingPath.tl !== 0 ? "This doesn't seem to be a valid URL" : JsxRuntime.jsx(ViewPreferences.make, {});
        break;
      case "profile" :
        let match$3 = settingPath.tl;
        if (match$3 !== 0) {
          switch (match$3.hd) {
            case "about" :
              tmp$1 = match$3.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/profile"
                }) : JsxRuntime.jsx(UnifiedYourProfileAboutSettings.make, {});
              break;
            case "basic_info" :
              tmp$1 = match$3.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/profile"
                }) : JsxRuntime.jsx(UnifiedYourProfileBasicInfoSettings.make, {});
              break;
            case "photos" :
              tmp$1 = match$3.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/profile"
                }) : JsxRuntime.jsx(UnifiedYourProfilePhotosSettings.make, {});
              break;
            case "social_media" :
              tmp$1 = match$3.tl !== 0 ? JsxRuntime.jsx(Redirect.make, {
                  path: "/account/profile"
                }) : JsxRuntime.jsx(UnifiedYourProfileSocialMediaSettings.make, {});
              break;
            default:
              tmp$1 = JsxRuntime.jsx(Redirect.make, {
                path: "/account/profile"
              });
          }
        } else {
          tmp$1 = JsxRuntime.jsx(UnifiedYourProfileSettings.make, {});
        }
        break;
      case "marketing_profile" :
      case "team_marketing_profile" :
        tmp$1 = JsxRuntime.jsx(Redirect.make, {
          path: "/account/account_profile"
        });
        break;
      case "users" :
        tmp$1 = settingPath.tl !== 0 ? "This doesn't seem to be a valid URL" : JsxRuntime.jsx(SubusersPageRelay.make, {});
        break;
      default:
        tmp$1 = "This doesn't seem to be a valid URL";
    }
  } else {
    tmp$1 = "This doesn't seem to be a valid URL";
  }
  return JsxRuntime.jsxs(Container.make, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: tmp
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(UnifiedSettingsPageSidebar.make, {}),
            className: "col-span-12 md:col-span-4 lg:col-span-3 mb-8 md:mb-0"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: _error => JsxRuntime.jsx(UnifiedSettingsRecovery.make, {}),
              children: tmp$1
            }),
            className: "col-span-12 md:col-span-8 lg:col-span-9"
          })
        ],
        className: "grid grid-cols-12 gap-x-4"
      })
    ]
  });
}

let Settings = {
  make: UnifiedAccountSettingsPage$Settings
};

function UnifiedAccountSettingsPage$Content(props) {
  let setting = props.setting;
  let match = useRefetchable(props.data);
  let currentAccountV5 = match[0].currentAccountV5;
  let legacyProfile = currentAccountV5 !== undefined ? currentAccountV5.profile.__typename === "PreUnifiedAccountProfile" : false;
  let polling = UseRelayPolling.use(match[1], undefined, legacyProfile, legacyProfile, 30000, undefined);
  if (Stdlib_Option.isSome(polling.error)) {
    return JsxRuntime.jsx(UnifiedSettingsRecovery.make, {});
  }
  if (currentAccountV5 === undefined) {
    return JsxRuntime.jsx(UnifiedSettingsRecovery.make, {});
  }
  let profile = currentAccountV5.profile;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(UnifiedAccountSettingsPage$Settings, {
        setting: setting,
        profileType: "Individual"
      });
    case "PreUnifiedAccountProfile" :
      return props.legacyPage;
    case "TeamAccountProfile" :
      return JsxRuntime.jsx(UnifiedAccountSettingsPage$Settings, {
        setting: setting,
        profileType: "Team"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
  }
}

let Content = {
  make: UnifiedAccountSettingsPage$Content
};

function UnifiedAccountSettingsPage$LoadedPage(props) {
  let data = use$1(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsx(UnifiedAccountSettingsPage$Content, {
    setting: props.setting,
    legacyPage: props.legacyPage,
    data: data.fragmentRefs
  });
}

let LoadedPage = {
  make: UnifiedAccountSettingsPage$LoadedPage
};

function UnifiedAccountSettingsPage$Page(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(UnifiedSettingsRecovery.make, {}),
    children: JsxRuntime.jsx(UnifiedAccountSettingsPage$LoadedPage, {
      setting: props.setting,
      legacyPage: props.legacyPage
    })
  });
}

let Page = {
  make: UnifiedAccountSettingsPage$Page
};

exports.Fragment = Fragment;
exports.Query = Query;
exports.Settings = Settings;
exports.Content = Content;
exports.LoadedPage = LoadedPage;
exports.Page = Page;
/* use Not a pure module */
